import { isArray } from "lodash";
import { ICalendar } from "src/Pages/Company/Absences/Calendars/Calendars.models";
import sortCaledarsByYear from "src/utils/Company/Absences/sortCaledarsByYear";

/**
 * Function splitting calendards retreived from API into two collections - active and inactive.
 * @param {array} data - collection of all calendards configured for particular company
 * @returns {array} Array of two collections of given calendars filtered by active status.
 */
export default (data?: ICalendar[]) => {
  if (!isArray(data)) return [];

  const activeCalendars = sortCaledarsByYear(
    data.filter((calendar) => calendar.active)
  );
  const inactiveCalendars = sortCaledarsByYear(
    data.filter((calendar) => !calendar.active)
  );

  return [activeCalendars, inactiveCalendars];
};
